<div class="wrap">
  <div class="options" *ngFor="let option of options">
    <div class="option">
      <app-checkbox
        [checked]="selectedOptionId === option.id"
        [id]="option.id"
        [i18nLabel]="option.i18nLabel"
        (valueChange)="onCheckboxValueChange($event)"
        [rightSlotTemplate]="option?.rightSlotTemplateRef"
      ></app-checkbox>
    </div>
  </div>
</div>
